const getOffset = (timeZone: string): number => {
  const now = new Date();

  const tzDate = new Date(now.toLocaleString('en-US', { timeZone }));
  const utcDate = new Date(now.toLocaleString('en-US', { timeZone: 'UTC' }));

  return Math.floor((tzDate.getTime() - utcDate.getTime()) / (1000 * 60 * 60));
};

export const getOffsetDifference = (timeZone: string): number => {
  const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const isTimezoneDefined = localTimezone !== 'Etc/Unknown';

  return getOffset(timeZone) - getOffset(isTimezoneDefined ? localTimezone : 'Europe/London');
};
